// @flow strict

import * as React from 'react';
import { Button, TextInput, Select2 } from '@ansarada/ace-react';
import OnBoardingLayout from '../OnBoardingLayout';
import styles from './styles.scss';
import type { QuestionOptionType } from '../../types';
import { getOutcomes, getSubOutcomes } from '../../helpers';
// $FlowFixMe
import outcomesData from '../../freetrial-data/outcomes.json';

type PropsType = {|
  title: string,
  onBack: () => void,
  onNext: () => void,
  part1: string,
  part2: string,
  part3: string,
  onSetPart1: string => void,
  onSetPart2: string => void,
  onSetPart3: string => void,
  part1Placeholder: string,
  part2Placeholder: string,
  part3Placeholder: string,
  part1QuestionOptions: Array<QuestionOptionType>,
  part2QuestionOptions: Array<QuestionOptionType>,
  part3QuestionOptions: Array<QuestionOptionType>,
  bgMobile: string,
  bgDesktop: string,
  enabledTransactionTypeIndustryQuestions: boolean,
|};

const Question2Outcome = (props: PropsType) => {
  const {
    title,
    onBack,
    onNext,
    part1,
    part2,
    part3,
    onSetPart1,
    onSetPart2,
    onSetPart3,
    part1Placeholder,
    part2Placeholder,
    part3Placeholder,
    part1QuestionOptions,
    part2QuestionOptions,
    part3QuestionOptions,
    enabledTransactionTypeIndustryQuestions,
  } = props;

  // prefill outcome if go back from next steps
  const prevOutcome = enabledTransactionTypeIndustryQuestions && part1 ? part1.split('|')[3] : '';
  const [selectedOutcome, setSelectedOutcome] = React.useState(prevOutcome);

  const disabled =
    (part1QuestionOptions.length > 0 && !part1) ||
    ((part2QuestionOptions.length > 0 || part1 === 'Other') && (part2 || '').trim().length === 0);

  const disabledWhenHasPart3 = !selectedOutcome || !part1 || !part2 || !part3;

  const mapSelect2Options = (questionOptions: Array<QuestionOptionType>) =>
    questionOptions.map(q => ({ value: q.value, label: q.text }));

  const part1Items = mapSelect2Options(part1QuestionOptions);
  const part2Items = mapSelect2Options(part2QuestionOptions);
  const part3Items = mapSelect2Options(part3QuestionOptions);

  let renderedQuestions = (
    <>
      <div className={styles.secondQuestion}>
        <Select2
          size="Medium"
          placeholder={part1Placeholder}
          value={part1}
          options={[{ title: '', items: part1Items }]}
          onChange={option => onSetPart1(option.value)}
          id="s5-outcome-main"
        />
      </div>
      {part2QuestionOptions.length > 0 && (
        <Select2
          size="Medium"
          placeholder={part2Placeholder}
          value={part2}
          options={[{ title: '', items: part2Items }]}
          onChange={option => onSetPart2(option.value)}
          id="s5-outcome-sub"
        />
      )}
      {part1 === 'Other' && (
        <TextInput
          id="s5-outcome-sub"
          clearable
          value={part2}
          placeholder="Let us know your specific outcome"
          onChangeValue={val => onSetPart2(val)}
          maxLength={99}
        />
      )}
    </>
  );

  if (enabledTransactionTypeIndustryQuestions) {
    const outcomeItems = getOutcomes(outcomesData);
    const subOutcomeItems = selectedOutcome ? getSubOutcomes(outcomesData, selectedOutcome) : [];
    renderedQuestions = (
      <>
        <div className={styles.secondQuestion}>
          <Select2
            size="Medium"
            placeholder="Select your outcome"
            value={selectedOutcome}
            options={[
              { title: '', items: outcomeItems.sort((a, b) => a.label.localeCompare(b.label)) },
            ]}
            onChange={option => {
              setSelectedOutcome(option.value);
              if (part1) onSetPart1('');
            }}
            id="s5-outcome-type"
          />
          {subOutcomeItems.length > 0 && (
            <Select2
              size="Medium"
              placeholder="Choose a specific area for your outcome"
              value={part1}
              options={[
                {
                  title: '',
                  items: subOutcomeItems.sort((a, b) => a.label.localeCompare(b.label)),
                },
              ]}
              onChange={option => onSetPart1(option.value)}
              id="s5-transaction-type"
            />
          )}
          {part1 && (
            <>
              <h2 className={styles.title}>What is your Industry?</h2>
              <Select2
                size="Medium"
                placeholder={part2Placeholder}
                value={part2}
                options={[
                  { title: '', items: part2Items.sort((a, b) => a.label.localeCompare(b.label)) },
                ]}
                onChange={option => onSetPart2(option.value)}
                id="s5-industry-group"
              />
            </>
          )}
          {part2 && (
            <Select2
              size="Medium"
              placeholder={part3Placeholder}
              value={part3}
              options={[
                { title: '', items: part3Items.sort((a, b) => a.label.localeCompare(b.label)) },
              ]}
              onChange={option => onSetPart3(option.value)}
              id="s5-industry-name"
            />
          )}
        </div>
      </>
    );
  }

  return (
    <OnBoardingLayout
      title={title}
      actionButtons={[
        <Button onClick={onBack} key="back" id="s5-back">
          Back
        </Button>,
        <Button
          onClick={onNext}
          key="next"
          variant="Primary"
          disabled={enabledTransactionTypeIndustryQuestions ? disabledWhenHasPart3 : disabled}
          id="s5-next"
        >
          Next
        </Button>,
      ]}
      bgMobile={props.bgMobile}
      bgDesktop={props.bgDesktop}
    >
      {renderedQuestions}
    </OnBoardingLayout>
  );
};

export default Question2Outcome;
